// extracted by mini-css-extract-plugin
export default {"warn":"warn---i3tcX","success":"success---Kw_kN"};